import {useCurrentScopeContext} from './useCurrentScopeContext'

export const useCurrentUser = () => {
  const scope = useCurrentScopeContext()
  return scope?.currentUser
}
